<template>
  <BaseHeader></BaseHeader>
  <div id="anchor_top"></div>
  <router-view></router-view>
  <BaseFooter></BaseFooter>
</template>

<script>
import BaseHeader from './components/BaseHeader.vue';
import BaseFooter from './components/BaseFooter.vue';

export default {
  name: 'App',
  components: {
    BaseHeader,
    BaseFooter,
  },
};
</script>

<style lang="scss">
@import "../node_modules/mdb-vue-ui-kit/src/scss/index.free";
html{
  scroll-behavior: auto !important;
  font-family: "meiryo" !important;
}
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
h2, h3 {
  color: white;
  font-weight: bold;
}
.wrapper{
  margin: auto;
  max-width: 1000px;
}
.container section h2{
  color:var(--primary);
}
.section-wrapper{
  max-width:1960px;
  margin:auto;
}
table , tbody, thead{
  border-width: 2.5px !important;
}
table , tbody, thead , tr, th, td{
  border-color: #808080 !important;
}

.no-p{
  padding:0px !important;
}
.no-m{
  margin:0px !important;
}
.nav a:not(.img-link) {
      color: var(--primary);
      text-decoration: none;
      position: relative;
      transition: .3s;
      &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: '';
        width: 0;
        height: 3px;
        transition: .3s;
        background-color: var(--primary);
      }
      &:hover::after {
        width: 100%;
      }
}
#section-title h3{
  padding-bottom: 15px;
  font-weight: bolder;
  color: #13115E;
  text-align: center;
  font-size: 2rem;
  letter-spacing: .1rem;
  margin-top: 10px;
}
.sub-page-title{
  color: #464f0c !important;
}
// top page 
// max-height: 575px;
.title {
  color: #fff;
  width: 300px;
  font-size: 24px;
  margin: 5% 0 3%;
  transform: skewX(-30deg);
  position: relative;
  padding: 0;
  max-height: 30px;
  height: 100%;

  &::before, &::after, span:before {
    content: '';
    position: absolute;
    background-color: #141084;
    top: 0;
    height: 30px;
  }

  &::before {
    width: 10px;
    left: 263px;
  }

  &::after {
    width: 7px;
    left: 297px;
  }

  span {
    min-width: 235px;
    padding: 0 10px;
    display: inline-block;
    left: 0;
    max-height: 30px;
    line-height: 30px;
    background-color: #b5cc24;
    position: relative;
    box-sizing: content-box;

    &::before {
      width: 10px;
      left: 280px;
    }
  }
}

  .w_btn {
    color: whitesmoke !important;
    // background-color: var(--tertiary) !important;
    // background-image: linear-gradient(to right, #d3e845, #6e7b14 );
    background-color: var(--secondary) !important;
    padding: 20px 0px !important;
    font-size: 2.5rem;
    margin: 2rem 0;
    align-items: center;
    border-radius: 7px;
    min-width: 200px;
    // background-image: -webkit-gradient(linear, left top, right top, from(var(--gradient-start)), to(var(--gradient-end)));
    // background-image: -webkit-linear-gradient(left, var(--gradient-start) 50%, var(--gradient-end) 100%);
    // background-image: linear-gradient(to bottom, var(--gradient-start) 50%, var(--gradient-end) 100%);
    box-shadow: inset 3px 3px 3px 2px rgba(0, 0, 0, 0.2);
    // -webkit-box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
    // box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
    text-decoration: none;
    line-height: 2.7rem;
    &:hover {
      -webkit-transform: translate(0, 2px);
      transform: translate(0, 2px);
      color: #fff;
      box-shadow: inset 3px 3px 3px 2px rgba(0, 0, 0, 0.2);
      // -webkit-box-shadow: 0 8px 15px rgba(0, 0, 0, .2);
      // box-shadow: 0 8px 15px rgba(0, 0, 0, .2);
    }

    @include media-breakpoint-down(md) {
      font-size: 1.7em;
      border-radius: 20px;
    }
    @include media-breakpoint-down(sm) {
      font-size: 1.5em;
      border-radius: 20px;
    }
  }

.cat_bg_1, .cat_bg_a{
  background-color: var(--category-bg-1);
}

.cat_bg_2, .cat_bg_b{
  background-color: var(--category-bg-2);
}

.cat_bg_3, .cat_bg_c{
  background-color: var(--category-bg-3);
}

.cat_bg_4, .cat_bg_d{
  background-color: var(--category-bg-4);
}

.cat_bg_5, .cat_bg_e{
  background-color: var(--category-bg-5);
}

.cat_bg_6, .cat_bg_f{
  background-color: var(--category-bg-6);
}

.cat_bg_7, .cat_bg_g{
  background-color: var(--category-bg-7);
}

.cat_bg_8, .cat_bg_h{
  background-color: var(--category-bg-8);
}


.cat_bg_9, .cat_bg_i{
  background-color: var(--category-bg-9);
}


#info_list {
  font-size: 1.2rem;
  @include media-breakpoint-down(md) {
    font-size: 1rem;
  }

  .info_date {
    @include media-breakpoint-up(md) {
      width: 180px;
    }
  }

  ul {
    border-top: 1px solid rgba(0, 0, 0, 0.125);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    color: black;
    font-weight: normal;
    a{
      background-color: var(--primary-02);
      transition: all ease 0.3s;
    }    
    a:hover{
      background-color: var(--primary-05);
    }
  }

  .list-group-item {
    padding: 1.4rem 1.5rem;
  }
}
</style>
